import {
  CalendarIcon,
  ChevronLeftIcon,
  GlobeAltIcon,
  LocationMarkerIcon,
} from "@heroicons/react/outline";
import { useTranslation } from "react-i18next";
import StudentModel from "../../api/models/StudentModel";
import UserProfilePictureAvatar from "../avatar/UserProfilePictureAvatar";
import { translateCountryName } from "../../helpers/options/countries";
import i18next from "i18next";

type StudentCardProps = {
  student: StudentModel | null;
  showKhetma: boolean;
};

export default function StudentCard(props: StudentCardProps) {
  const { student, showKhetma } = props;
  const LocalBasePath = "page.supervisor.student";
  const { t } = useTranslation("", {
    keyPrefix: LocalBasePath,
  });
  return (
    <>
      <div className="w-full    py-2   flex-col justify-center  gap-4 inline-flex">
        <div className="self-stretch justify-end items-center gap-4 inline-flex">
          <UserProfilePictureAvatar
            className="w-16 h-16 rounded-full"
            profilePictureUrl={student?.profile_picture_url}
          />

          <div className="w-full flex  flex-col ">
            <div className="flex-1  flex-col   inline-flex">
              <p className=" text-gray-600 text-[22px] capitalize leading-8 font-semibold">
                {student?.fullNameWithoutMiddle}
              </p>

              <div className="w-full  items-center gap-4 flex">
                {!!student?.country && (
                  <div className="flex gap-1 items-center">
                    <LocationMarkerIcon className="w-5 h-5 text-gray-500" />
                    <p className="text-gray-500 text-sm">
                      {translateCountryName(student.country, i18next.language)}
                    </p>
                  </div>
                )}
                {!!student?.getAge() && (
                  <div className="flex gap-1  items-center ">
                    <CalendarIcon className="w-5 h-5 text-gray-500" />
                    <p className="text-gray-500 text-sm">
                      {t("age", { age: student?.getAge() }) || ""}
                    </p>
                  </div>
                )}
                {!!student?.native_language && (
                  <div className="flex gap-1 items-center">
                    <GlobeAltIcon className="w-5 h-5 text-gray-500" />
                    <p className="text-gray-500 text-sm">
                      {t(student.native_language.toLowerCase())}
                    </p>
                  </div>
                )}
              </div>
            </div>
          </div>
          {!!showKhetma && (
            <button className=" w-auto flex-none  flex-nowrap bg-white  py-[9px] px-4  rounded-md shadow-sm border border-gray-300 flex gap-2  items-center">
              <p className="w-auto text-sm font-medium text-gray-700">
                {t("khetmaDetails")}
              </p>
              <ChevronLeftIcon className="w-5 h-5 text-gray-700 cursor-pointer ltr:rotate-180" />
            </button>
          )}
        </div>
      </div>
    </>
  );
}
